import { apiClient } from '../api/apiClient';

export type AttendanceComment = {
  commentId: number;
  attendanceId: number;
  comment: string;
  latitude: number;
  longitude: number;
  locationCapturedAt: string;
  createdAt: string;
};
export type AttendanceComments = {
  eligible: boolean;
  canAdd: boolean;
  items: AttendanceComment[];
};
export async function getAttendanceComments(
  attendanceId: number,
): Promise<AttendanceComments> {
  const response = await apiClient.get<{ data: AttendanceComments }>(
    `/attendance/${attendanceId}/comments`,
  );
  return response.data.data;
}
export async function addAttendanceComment(
  attendanceId: number,
  input: {
    comment: string;
    latitude: number;
    longitude: number;
    locationCapturedAt: string;
  },
): Promise<AttendanceComment> {
  const response = await apiClient.post<{ data: AttendanceComment }>(
    `/attendance/${attendanceId}/comments`,
    input,
  );
  return response.data.data;
}
